// extracted by mini-css-extract-plugin
export var alertIcon = "_to-0";